<!--
 * @Author: your name
 * @Date: 2021-07-09 17:25:06
 * @LastEditTime: 2021-07-21 14:03:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\contactUs.vue
-->
<template>
  <div>
    <div v-if="contactUsInfo.isHidden" class="floor-hidden">
      <el-divider
        >{{
          contactUsInfo.title ? contactUsInfo.title : '联系我们编辑'
        }}区</el-divider
      >
      <div class="open-btn">
        <eui-btn width="80" type="primary" @click.native.prevent="hiddenFloor"
          >显示</eui-btn
        >
      </div>
    </div>
    <div v-else class="contactUs flex">
      <div class="call">
        <img src="./img/Vector.png" alt="" />
      </div>
      <div class="title">
        <p>联系我们</p>
        <p>contact us</p>
      </div>
      <div v-show="contactUsInfo.contacts" class="phone">
        {{ contactUsInfo.contacts }}：
      </div>
      <div class="phone">{{ contactUsInfo.phone }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeName: {
      type: String,
      default: '',
    },
    contactUsInfo: {
      type: Object,
      default() {
        return {
          isHidden: false,
          title: '联系我们编辑',
          phone: '',
          contacts: '',
        };
      },
    },
  },

  methods: {
    hiddenFloor() {
      // eslint-disable-next-line vue/no-mutating-props
      this.contactUsInfo.isHidden = !this.contactUsInfo.isHidden;
      this.$parent.choosenComments('');
      console.log(this.contactUsInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.contactUs {
  height: 120px;
  width: 100%;

  background: $main-table-th-bg;
  justify-content: center;
  align-items: center;
  .call {
    width: 50px;
    height: 50px;
    text-align: center;

    background: #c4c4c4;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 18px;
      height: 22px;
    }
  }
  .title {
    margin: 0 50px 0 20px;
    p {
      color: $c3;
      line-height: 32px;
      font-size: 22px;
      text-align: right;
    }
  }
  .phone {
    font-size: 30px;
    color: $c3;
  }
}
.floor-hidden {
  width: 1200px;

  background: #f8f8f9;
  position: relative;
  .open-btn {
    position: absolute;
    top: -16px;
    right: 0;
  }
  p {
    width: 100%;
    height: 0;
    border-top: 1px solid #eee;
  }
}
</style>
